import React from "react";
import { ASSETS } from "../data/assets";

export const Mariage = () => {
  return (
    <section id="mariage" data-testid="mariage-section" className="relative h-[80vh] min-h-[560px] overflow-hidden">
      <img
        src={ASSETS.weddingHero}
        alt="Couple ouverture de bal mariage"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0E1A2B] via-[#0E1A2B]/70 to-[#0E1A2B]/10" />
      <div className="relative h-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 flex items-center">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#C47A66]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#C47A66]">
              Préparation mariage
            </span>
          </div>
          <h2 className="serif font-light text-[#F7F3EA] text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            Une <span className="italic gold-text">ouverture de bal</span><br /> que vous n'oublierez pas.
          </h2>
          <p className="mt-7 text-base md:text-lg text-[#F7F3EA]/80 max-w-xl font-light leading-relaxed">
            On choisit ensemble votre musique, on construit une chorégraphie adaptée à votre niveau et à votre couple, et on travaille jusqu'à ce que vous vous sentiez parfaitement à l'aise.
          </p>
          <a
            href="#contact"
            data-testid="mariage-cta"
            className="mt-9 inline-flex items-center gap-3 px-8 py-4 bg-[#C9A869] text-[#0E1A2B] text-[12px] tracking-[0.25em] uppercase font-medium hover:bg-[#DCC28E] transition-colors duration-500"
          >
            Préparer mon mariage
          </a>
        </div>
      </div>
    </section>
  );
};
